import { Flex } from "components/core/Flex";
import { RadioGroup, RadioGroupItem } from "components/core/RadioGroup";
import { Text } from "components/core/Text";

import { useCompletionFormContext } from "./useCompletionFormContext";

const FinalHarvestingSection = () => {
  const { watch, setValue } = useCompletionFormContext();
  const isFinal = watch("isFinal");

  return (
    <Flex gap={2} justify="between">
      <Text weight="semibold">
        Is this your final harvesting? <Text color="destructive">*</Text>
      </Text>
      <RadioGroup
        value={String(isFinal)}
        onValueChange={(value) => setValue("isFinal", value === "true")}
      >
        <RadioGroupItem value="true">Yes</RadioGroupItem>
        <RadioGroupItem value="false">No</RadioGroupItem>
      </RadioGroup>
    </Flex>
  );
};

export default FinalHarvestingSection;
